import { createGlobalStyle } from 'styled-components'

//generates global style for our project
const GlobalStyle = createGlobalStyle`
    html,
    body {
    padding: 0;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
        Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    }
    html {
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    }
    a {
    color: inherit;
    text-decoration: none;
    }
`

export default GlobalStyle